import { useState } from "@";

// Hook for pagination
export function usePagination(initialState = { rows: 0, size: 10, page: 1 }) {
  const [pg, setPg] = useState(initialState);

  const updatePg = (updates) => {
    if (updates.size) {
      updates.page = 1;
    }
    setPg((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  return {
    pg,
    updatePg,
  };
}
